import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'peps-marketplace-maintenance',
	imports: [TranslatePipe, RouterLink],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './marketplace-maintenance.component.html',
})
export class MarketplaceMaintenanceComponent implements OnInit {

	constructor(
		private readonly titleService: Title,
		private readonly translate: TranslateService,
	) {}

	ngOnInit(): void {
		this.titleService.setTitle('Team Peps - ' + this.translate.instant('page.marketplace.maintenance.title'));
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}
}
